import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  recordId: null,
  communicationLogs: [],
  showMoreCommsButton: true,
  paginationPage: 1,
  paginationSize: 25,
});

const getters = {
  recordId(state) {
    return state.recordId;
  },
  communicationLogs(state) {
    return state.communicationLogs;
  },
};

const mutations = {
  addComms(state, data) {
    const allComms = [
      ...state.communicationLogs,
      ...data.communicationLogs
    ];

    state.paginationPage++;

    if (data.communicationLogs.length < state.paginationSize) {
      state.showMoreCommsButton = false;
    }

    state.communicationLogs = allComms;
  },
  reset(state) {
    state.recordId = null;
    state.communicationLogs = [];
  },
  setActiveFollowUpStateItemId(state, recordId) {
    state.recordId = recordId;
  }
};

const actions = {
  setup({commit, dispatch, state}, recordId) {
    // Make sure you can subscribe to more then one at a time
    if (state.recordId !== null && state.recordId !== recordId) {
      unsubscribeToChannel("activeFollowUpStateItem", state.recordId);
    }

    commit('setActiveFollowUpStateItemId', recordId);
    subscribeToChannel("activeFollowUpStateItem", recordId);

    dispatch('getCommLogs', recordId);
  },
  getCommLogs({commit, state}, recordId) {
    return api.clientStore.initActiveFollowUpStateItem(recordId, state.paginationPage, state.paginationSize)
      .then((response) => {
        commit('addComms', response.data);
      });
  },
  tearDown({commit, state}) {
    unsubscribeToChannel("activeFollowUpStateItem", state.recordId);
    commit('reset');
  },
};

const ActiveFollowUpStateItemStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ActiveFollowUpStateItemStore;
